var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRequestResponse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0318 6.09869L8.66856 3.82779L10.8961 1.41798",
    stroke: "#4152B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9783 16.2884C16.9783 17.5635 15.9668 18.5807 14.7392 18.5807C13.5115 18.5807 12.5 17.5635 12.5 16.2884C12.5 15.0133 13.5115 13.9961 14.7392 13.9961C15.9668 13.9961 16.9783 15.0133 16.9783 16.2884Z",
    stroke: "#4152B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14484 16.2903C5.14484 17.5654 4.13332 18.5826 2.90567 18.5826C1.67803 18.5826 0.666504 17.5654 0.666504 16.2903C0.666504 15.0152 1.67803 13.998 2.90567 13.998C4.13332 13.998 5.14484 15.0152 5.14484 16.2903Z",
    stroke: "#4152B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14484 3.87433C5.14484 5.14943 4.13332 6.16662 2.90567 6.16662C1.67803 6.16662 0.666504 5.14943 0.666504 3.87433C0.666504 2.59923 1.67803 1.58203 2.90567 1.58203C4.13332 1.58203 5.14484 2.59923 5.14484 3.87433Z",
    stroke: "#4152B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62402 6.16992L2.64603 13.4955",
    stroke: "#4152B4",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6571 13.4559L14.6573 6.67981C14.6574 5.02291 13.3142 3.67969 11.6573 3.67969H8.66748",
    stroke: "#4152B4",
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestResponse);
export default __webpack_public_path__ + "static/media/request-response.6cc861ee.svg";
export { ForwardRef as ReactComponent };